<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">
    <div>
      <perfect-scrollbar [config]="config" class="content-sidebar-ps">
        <mat-toolbar class="desktop-logo"><img src="./assets/images/white-logo.png" alt="company-logo" /></mat-toolbar>
        <mat-nav-list class="menu-items">
          <app-menu-list-item *ngFor="let item of navItems" [item]="item">
            <mat-icon>{{ item.iconName }}</mat-icon>
          </app-menu-list-item>
        </mat-nav-list>
      </perfect-scrollbar>
    </div>
    <div class="version">V.0.7</div>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar class="layouts-container">
      <div class="d-flex">
        <button type="button" mat-icon-button (click)="drawer.toggle()"
          *ngIf="isHandset$ | async">
          <mat-icon>menu</mat-icon>
        </button>
        <img src="./assets/images/logo.svg" alt="company-logo" class="mobile-logo" />
      </div>
      <app-header></app-header>
    </mat-toolbar>
    <div class="content-wrapper">
      <router-outlet></router-outlet>
      <app-footer></app-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>